import { render, staticRenderFns } from "./CardOrderShipping.vue?vue&type=template&id=1341815f&scoped=true&"
import script from "./CardOrderShipping.vue?vue&type=script&lang=js&"
export * from "./CardOrderShipping.vue?vue&type=script&lang=js&"
import style0 from "./CardOrderShipping.vue?vue&type=style&index=0&id=1341815f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1341815f",
  null
  
)

export default component.exports